import { Component, OnInit, Input } from '@angular/core';
import { AlertasService } from '../../providers/alertas.service';

@Component({
  selector: 'app-alertas',
  templateUrl: './alertas.component.html',
  styleUrls: ['./alertas.component.scss']
})
export class AlertasComponent implements OnInit {

  alertasShow: boolean = false;
  cargando: boolean = true;
  public listadoAlertas = [];
  public cantidadAlertas: Number = 0;
  buscarAlertas: any;
  segundos = 30;
  constructor(
    private alertaService: AlertasService,
  ) { }

  ngOnInit() {
    // this.traerAlertas();
  }

  ngAfterViewInit(): void {
    this.checkAlertasLoop();
  }

  checkAlertasLoop(): void {
    // Checkear si hay alertas loop
    setTimeout(() => {
      this.traerAlertas();
    }, 1750);

    this.buscarAlertas = setInterval(() => {
      this.traerAlertas();
    }, this.segundos * 1000);
  }

  traerAlertas() {
    this.cargando = true;
    this.alertaService.getAlertas().subscribe(
      respuesta => {
        this.cargando = false;
        this.listadoAlertas = respuesta.data.alertas;
        this.cantidadAlertas = respuesta.data.cantidadAlertas;
      }
    )
  }

  ngOnDestroy(): void {
    // al desloguearse dejar de buscar alertas
    clearInterval(this.buscarAlertas);
  }

  abrirAlertas() {
    if (this.alertasShow) {
      this.alertasShow = false;
    } else {
      this.alertasShow = true;
    }
  }

  alertaLeida(idAlerta){
    this.alertaService.alertaLeida(idAlerta).subscribe(
      respuesta => {
        this.traerAlertas();
      }
    )
  }

}
